import React from "react";
import { ScrollView as NScrollView, IScrollViewProps } from "native-base";

export const ScrollView: React.FC<IScrollViewProps> = (props) => {
  return <NScrollView {...props} />;
};

export default ScrollView;
